export const Forward = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.625 18.75L18.375 12L11.625 5.25" stroke="black" strokeWidth="2" strokeLinecap="square"/>
        </svg>
    );
  };